import * as ActionTypes from './actionTypes';

export function selectInspectorItem(id, itemType) {
  return {
    type: ActionTypes.INSPECTOR_SELECT_ITEM,
    id,
    itemType,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/inspector.js